export enum PaginationCount {
  'TWENTY' = '20',
  'FIFTY' = '50',
  'HUNDERED' = '100',
}

export const CONST_PAGINATION_COUNT = Object.values(PaginationCount);
